import { CompanyInner } from "./CompanyInner";

export const Default = () => (
	<footer className="bg-dark relative">
		<div className="mx-auto p-2 md:p-3">
			<CompanyInner />
		</div>
	</footer>
);
